// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"99f79cf3386748b99b45","293":"0e8600b061e9aa0c654b","518":"c719fd97fbdee773e1b6","779":"44a8b0a79b522922201f"}[chunkId] + ".js";
};